import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useInputColumn,
  BaseButton,
  useCreateModal
} from 'xrk-components';
import { formatter } from '@/utils';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank';
import { notInvoicedList } from '@V/invoice/src/data-source/apis';
import { ORDER_TYPE } from '@constants/order';
import InvoiceOpenDialog from './invoice-open-dialog';
import { InvoiceWtdk1Dialog } from './invoice-wtdk';
import { useRouteMeta } from '@hooks/common';
import { useJumpToFinishedOrderList, useJumpToOrderDetail } from '@hooks/order';
import { IS_PLATFORM_TYPE_1 } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-uninvoiced-list',
  setup(__props) {

const FUNCTION_CODE_ORDER_TYPE = {
  1: [
    ORDER_TYPE[1],
    ORDER_TYPE[4],
    ORDER_TYPE[5],
    ORDER_TYPE[6],
    ORDER_TYPE[8]
  ],
  2: [ORDER_TYPE[1], ORDER_TYPE[4], ORDER_TYPE[5], ORDER_TYPE[8]],
  3: [ORDER_TYPE[6]],
  8: [ORDER_TYPE[1], ORDER_TYPE[10]]
};

const xrkTableRef = ref();
const routeMeta = useRouteMeta();
const isSupplier = [3].includes(+routeMeta.functionCode);
const isAsp = [2].includes(+routeMeta.functionCode);
const isDbgys = routeMeta.functionCode == 8;
const currentOrderType = FUNCTION_CODE_ORDER_TYPE[routeMeta.functionCode];

const getListAjax = async params => {
  return notInvoicedList(params);
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useInputColumn({
      prop: 'theSellerName',
      label: '企业名称',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useInputColumn({
      prop: 'userDefinedOrderNo',
      label: '订单编号',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useSelectColumn({
      prop: 'userDefinedOrderType',
      label: '订单类型',
      defaultValue: currentOrderType[0].value,
      config: {
        clearable: false,
        placeholder: '请选择',
        options: currentOrderType
      }
    }),
    useSelectColumn({
      prop: 'payPassagewayCode',
      label: '支付通道',
      config: {
        placeholder: '请选择',
        options: PAY_PASSAGEWAY_MAPPING
      }
    }),
    useInputColumn({
      prop: 'projectName',
      label: '项目名称',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    })
  ],
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  otherComponents: [
    (isAsp || isSupplier) && {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['未开票订单_申请开票']]}
              type="primary2"
              click={async () => {
                useCreateModal(
                  InvoiceOpenDialog,
                  {
                    onSuccess() {
                      xrkTableRef.value.initCurrentList();
                    }
                  },
                  getCurrentInstance()
                );
              }}
            >
              申请开票
            </BaseButton>
          </>
        );
      }
    },
    isAsp &&
      IS_PLATFORM_TYPE_1 && {
        render() {
          return (
            <>
              <BaseButton
                v-resource={[['未开票订单_申请委托代开发票']]}
                type="primary2"
                click={async () => {
                  useCreateModal(InvoiceWtdk1Dialog, {
                    onSuccess() {
                      xrkTableRef.value.initCurrentList();
                    }
                  });
                }}
              >
                申请委托代开发票
              </BaseButton>
            </>
          );
        }
      }
  ].filter(item => item)
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '购买方',
      prop: 'purchaserName',
      width: 300
    }),
    useTableColumn({
      label: '项目名称',
      prop: 'projectName',
      width: 300
    }),
    useTableColumn({
      label: '订单编号',
      prop: 'userDefinedOrderNo',
      width: '260px',
      render({ row }) {
        return isDbgys ? (
          <span>{row.userDefinedOrderNo}</span>
        ) : (
          <BaseButton
            link
            onClick={() => {
              useJumpToFinishedOrderList(row.userDefinedOrderNo, {
                pageName: 'finished',
                method: 'push'
              });
            }}
          >
            {row.userDefinedOrderNo}
          </BaseButton>
        );
      }
    }),
    useTableColumn({
      label: '订单类型',
      prop: 'userDefinedOrderType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => ORDER_TYPE[cellValue].label)
    }),
    useTableColumn({
      label: '销售方',
      prop: 'theSellerName',
      width: 300
    }),
    useTableColumn({
      label: '收款时间',
      prop: 'receiveAt',
      width: '180px',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '支付通道',
      prop: 'payPassagewayCode',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => PAY_PASSAGEWAY_MAPPING[cellValue].label
        )
    }),
    useTableColumn({
      label: '金额',
      prop: 'userDefinedPrice',
      width: '180px',
      render({ row }) {
        return isDbgys ? (
          <span> {formatter.fen2yuan(row.userDefinedPrice)}</span>
        ) : (
          <BaseButton
            link
            onClick={() => {
              useJumpToOrderDetail(row.userDefinedOrderNo, { method: 'push' });
            }}
          >
            {formatter.fen2yuan(row.userDefinedPrice)}
          </BaseButton>
        );
      }
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XrkTable), {
    ref_key: "xrkTableRef",
    ref: xrkTableRef,
    getListAjax: getListAjax,
    searchConfig: searchConfig.value,
    tableConfig: tableConfig.value
  }, null, 8, ["searchConfig", "tableConfig"]))
}
}

})